/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_firstload = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	/**
	None yet
	**/
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {
		
		/*
		Trigger: modal and popup preloader
		*/
		images.preload();
		modal.onready();
		popup.onready();
		form.onready();
		if(pollConnection === 1) { poll_connection.onready(); }
		
		/*
		Trigger: onready classes
		*/
		specific_mobilemenu.onready();

		// /*
		// Init: Click menu navigation
		// */
		// $(document).on('click','.js-link',function() {
		// 	var href = $(this).data('url');
			
		// 	specific_360.updateUrl(href);

		// });

		/*
		Menu button
		*/
		$('.js-menu-button').on('click',function() {
			
			if(
				$('.js-menu-button').find('.inside').hasClass('active')
			) {
				$('.js-menu').find('nav').hide();
				$('.js-menu-button').find('.inside').removeClass('active');
			} else {
				$('.js-menu').find('nav').show();
				$('.js-menu-button').find('.inside').addClass('active');
			}

		});

		/*
		Trigger Classes: Onready
		*/
		// specific_360.toggleInfo(0);
		specific_overlayopening.onready();
		specific_menu.onready();

		/*
		Init: Info puller
		*/
		$(document).on('click','.js-info-puller',function() {
			specific_360.toggleInfo();
		});

		/*
		Init: Info puller
		*/
		$(document).on('click','.js-button-helpscreen',function() {
			popup.open(1,1,'helpscherm');
		});	

	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	// none
	
}).apply(specific_interactions_firstload); 